import { render, staticRenderFns } from "./CDNIcon.vue?vue&type=template&id=e5d1fb4a&scoped=true&"
import script from "./CDNIcon.vue?vue&type=script&lang=js&"
export * from "./CDNIcon.vue?vue&type=script&lang=js&"
import style0 from "./CDNIcon.vue?vue&type=style&index=0&id=e5d1fb4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d1fb4a",
  null
  
)

export default component.exports